import { ENVIRONMENT_VALUES } from './ENVIRONMENT_VALUES';
import type { EnvironmentValue } from '../types/EnvironmentValue';

/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Distributor API-specific environment variable key constants for convenient access</blockquote>
 * 
 * @example
 * ```typescript
 * import { DISTRIBUTOR_CONSTANTS } from '@shared/utils';
 * import { getEnvironmentValue } from '@shared/utils';
 * 
 * const apiKey = await getEnvironmentValue(DISTRIBUTOR_CONSTANTS.API_KEY);
 * ```
 */
export const DISTRIBUTOR_CONSTANTS = {
  API_KEY: ENVIRONMENT_VALUES.DISTRIBUTOR.DISTRIBUTOR_API_KEY,
} as const satisfies Record<string, EnvironmentValue>;
